import { useInitParams } from '@onramp/v2/client/contexts/initParams/InitParamsContext';
import { useDefaultAsset as pureUseDefaultAsset } from '@onramp/v2/client/utils/destinationWallets/useDefaultAsset';
import { useGuestOnrampV2StoreValue } from '@onramp/v2/client/views/guest/onramp/state/store';

import { useAssetsAndNetworks } from './useAssetsAndNetworks';
import { useDestinationWallets } from './useDestinationWallets';

export const useDefaultAsset = () => {
  const assetsAndNetworks = useAssetsAndNetworks();
  const destinationWallets = useDestinationWallets();
  const { defaultAsset: defaultAssetParam, defaultNetwork: defaultNetworkParam } =
    useInitParams().initParams;
  const { unavailableAssets } = useGuestOnrampV2StoreValue();

  return pureUseDefaultAsset({
    availableAssetsQueryRef: assetsAndNetworks,
    defaultAssetParam,
    defaultNetworkParam,
    destinationWallets,
    getAvailableNetworksQueryRef: assetsAndNetworks,
    excludeAssetUuids: unavailableAssets.map((asset) => asset.uuid),
  });
};
